const phrases = [
  "Olive that funding",
  "Live up to your expectations",
  "Yes when others say no",
  "Get OliveUp",
  "All credit types welcome",
  "The fun-loving funding team",
  "Small biz, big dreams",
];

export default function Marquee() {
  const items = [...phrases, ...phrases];
  return (
    <section
      data-testid="marquee-section"
      className="marquee-hover-pause relative border-y border-border bg-secondary/60 py-5 overflow-hidden"
    >
      <div className="marquee-inner flex animate-marquee whitespace-nowrap gap-12">
        {items.map((p, i) => (
          <span
            key={i}
            className="font-display text-lg md:text-xl font-bold uppercase tracking-tight text-primary inline-flex items-center gap-12"
          >
            {p}
            <span className="text-[#F5B82E] text-2xl">●</span>
          </span>
        ))}
      </div>
    </section>
  );
}
